import {
  MarketTab,
  TabsWrapper,
} from 'pages/Optimisation/components/MarketTabs/MarketTabs.styled';
import { TabsProps } from 'pages/Optimisation/components/MarketTabs/MarketTabs.types';

export const MarketTabs = <T = unknown,>({
  options,
  onChange,
  selected,
}: TabsProps<T>) => {
  return (
    <TabsWrapper data-testid="market-tabs">
      {options.map((option) => (
        <MarketTab
          key={option.display}
          data-testid="lj-chip"
          variant="transparent"
          $selected={Boolean(selected && option.value === selected)}
          onClick={() => onChange(option.value)}
        >
          {option.display}
        </MarketTab>
      ))}
    </TabsWrapper>
  );
};
